import { router } from "@inertiajs/react"
import type { AiSource } from "@/entities/ai/types"

interface Props {
  sources: AiSource[]
  workspaceSlug: string
}

export function SourceLinks({ sources, workspaceSlug }: Props) {
  if (!sources.length) return null

  return (
    <div className="mt-2 flex flex-wrap gap-1">
      {sources.map(source => (
        <button
          key={source.page_id}
          onClick={() => router.visit(`/${workspaceSlug}/${source.page_slug}`)}
          title={source.page_slug.replaceAll("/", " > ")}
          className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/20 hover:bg-blue-100"
        >
          {source.page_title}
        </button>
      ))}
    </div>
  )
}
